import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export class ApiConfig {
  public static get rootUrl(): string {return environment.root};
  public static get toggleLicense(): string { return `${this.rootUrl}license/toggleStatus/`; }
  public static get deleteLicense(): string { return `${this.rootUrl}license/remove/`; }
  public static get fetchLicenses(): string { return `${this.rootUrl}license/getList`; }
  public static get downloadLicense(): string { return `${this.rootUrl}license/download/`; }
  public static get fetchUtilities(): string { return `${this.rootUrl}utility/getList`; }
  public static get deleteUtility(): string { return `${this.rootUrl}utility/delete/`; }
  public static get createLicense(): string { return `${this.rootUrl}license/create`; }
  public static get fetchAllUtilities(): string { return `${this.rootUrl}utility/getAll`; }
  public static get getLicenseDetail(): string { return `${this.rootUrl}license/getLicenseDetails/`; }
  public static get updateLicense(): string { return `${this.rootUrl}license/update`;}
  public static get fetchPricing(): string { return `${this.rootUrl}pricing/getList`; }
  public static get fetchDetailsPricing(): string { return `${this.rootUrl}pricing/fetchDetails`; }
  public static get createPricing(): string { return `${this.rootUrl}pricing/create`; }
  public static get updatePricing(): string { return `${this.rootUrl}pricing/update`; }
  public static get deletePricing(): string { return `${this.rootUrl}pricing/delete/`; }
  public static get login(): string { return `${this.rootUrl}auth/login`;}
  public static get createUtility(): string { return `${this.rootUrl}utility/create`;}
  public static get editUtility(): string { return `${this.rootUrl}utility/update`;}
  public static get fetchUserList(): string { return `${this.rootUrl}user/getUsersList`;}
  public static get deleteUser(): string { return `${this.rootUrl}user/delete/`;}
  public static get updateUser(): string { return `${this.rootUrl}user/update`;}
  public static get toggleUserStatus(): string { return `${this.rootUrl}user/toggleStatus/`;}
  public static get fetchPlatforms(): string { return `${this.rootUrl}platform/getList`;}
  public static get deletePlatform(): string { return `${this.rootUrl}platform/delete/`;}
  public static get registerPlatform(): string { return `${this.rootUrl}platform/register/`; }
  public static get togglePlatform(): string { return `${this.rootUrl}platform/toggleStatus/`; }
  public static get generateKey(): string { return `${this.rootUrl}platform/generateKey/`; }
  public static get getPricingList(): string { return `${this.rootUrl}pricing/getAll`; }
  public static get register(): string { return `${this.rootUrl}register/signup`; }
  public static get forgotPassword(): string { return `${this.rootUrl}user/forgotPassword`; }
  public static get updatePassword(): string { return `${this.rootUrl}user/updatePassword`; }
  public static get fetchPartnerList(): string { return `${this.rootUrl}partnerComp/getList`; }
  public static get createPartnerComponent(): string { return `${this.rootUrl}partnerComp/create`; }
  public static get updatePartnerComponent(): string { return `${this.rootUrl}partnerComp/update`; }
  public static get deletePartnerComponent(): string { return `${this.rootUrl}partnerComp/delete/`; }


}
